export default "__VITE_ASSET__D7iS3Lr1__"